import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";  // Import WhatsApp icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";  // Import FontAwesomeIcon

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
  return (
    <div className="works">
      <Card
        icon={faBriefcase}
        title="Work"
        body={
          <div className="works-body">
            {/* Facebook Work Section */}
            <div className="work">
              <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
                <img
                  src="./facebook.png"
                  alt="facebook"
                  className="work-image"
                />
                <div className="work-title">Facebook</div>
              </a>
              <div className="work-subtitle">Konica Repair</div>
              <div className="work-duration">2021 - Present</div>
            </div>

            {/* WhatsApp Work Section */}
            <div className="work">
            <a href="https://wa.me/250781578901" target="_blank" rel="noreferrer">
  <FontAwesomeIcon
    icon={faWhatsapp}  // Use WhatsApp icon
    className="work-image"
    style={{ fontSize: "40px", color: "#25D366" }}  // Customize size and color
  />
  <div className="work-title">WhatsApp</div>
</a>

              <div className="work-subtitle">Konica Repair</div>
              <div className="work-duration">2021 - Present</div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default Works;
